import { withIcon } from "../Icon"

export const IconEmail = withIcon(
  '<svg xmlns="http://www.w3.org/2000/svg" fill="none"><path fill="#323333" d="M20.334 7c0-.917-.75-1.667-1.667-1.667H5.334c-.917 0-1.667.75-1.667 1.667v10c0 .917.75 1.667 1.667 1.667h13.333c.917 0 1.667-.75 1.667-1.667V7Zm-1.667 0L12 11.167 5.334 7h13.333Zm0 10H5.334V8.667L12 12.834l6.667-4.167V17Z"/></svg>',
)
